// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-container[data-v-1812f488] {\n  padding: 20px;\n}\n.upload-container .customer-table[data-v-1812f488] {\n  margin-top: 20px;\n}\n.upload-container .customer-table .el-icon-delete[data-v-1812f488] {\n  margin-left: 5px;\n}", ""]);
// Exports
module.exports = exports;
